export const MSAL_CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID;
export const MSAL_TENANT_ID = import.meta.env.VITE_MSAL_TENANT_ID;
export const MSAL_REDIRECT_URI = import.meta.env.VITE_MSAL_REDIRECT_URI;
export const MSAL_POST_LOGOUT_REDIRECT_URI = import.meta.env
  .VITE_MSAL_POST_LOGOUT_REDIRECT_URI;
export const MSAL_SCOPES = import.meta.env.VITE_MSAL_SCOPES.split(' ');
export const API_SCOPES = import.meta.env.VITE_API_SCOPES.split(' ');
export const API_URL = import.meta.env.VITE_API_URL;
export const INVENTORY_API_URL = import.meta.env.VITE_INVENTORY_API_URL;
export const INVENTORY_API_SCOPES =
  import.meta.env.VITE_INVENTORY_API_SCOPES.split(' ');
export const HUB_API_URL = import.meta.env.VITE_HUB_API_URL;
export const HUB_SCOPES = import.meta.env.VITE_HUB_SCOPES.split(' ');
export const PROXY_API_BASE_URL = import.meta.env.VITE_PROXY_API_BASE_URL;
export const APPLICATIONINSIGHTS_CONNECTION_STRING = import.meta.env.VITE_APP_CONNECTION_STRING;
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || undefined;